import axios from 'axios';
import { cacheAdapterEnhancer } from 'axios-extensions';

export default axios.create({
    baseURL: '/api/',
    headers: { 'Cache-Control': 'no-cache' },
    adapter: cacheAdapterEnhancer(axios.defaults.adapter)
});
